<script>
import CommonTableComponent from "@/components/table.vue";

import appConfig from "@/app.config.json";
import tableSearch from "@/mixins/tableSearch";
import pagination from "@/mixins/pagination";
import router from "@/mixins/router";
import Layout from "@/views/layouts/main.vue";
import apiEndpoints from "@/services/apiEndpoints";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import datetime from "@/mixins/datetime";
import sweetAlert from "@/mixins/sweetAlert";

export default {
  name: "Manifesh",
  page: {
    title: "マニフェスト検索",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mixins: [tableSearch, pagination, router, datetime,sweetAlert],
  components: {
    Layout,
    CommonTableComponent,
    Multiselect,
    DatePicker,
  },
  data() {
    return {
      waste_categories: [],
      factories:[],
      data: [],
      filters: {
        number_of_issue: this.$route.query.number_of_issue || "",
        control_number: this.$route.query.control_number || "",
        number_of_issue_get_blank: this.$route.query.number_of_issue_get_blank || "",
        manifest_type_cd: this.$route.query.manifest_type_cd
        ? (this.$route.query.manifest_type_cd.includes(',')
          ? this.$route.query.manifest_type_cd.split(',')
          : [this.$route.query.manifest_type_cd])
        : [],
        classifications: this.$route.query.classifications
        ? (this.$route.query.classifications.includes(',')
          ? this.$route.query.classifications.split(',')
          : [this.$route.query.classifications])
        : [],
        disposal_vendor_site_name: this.$route.query.disposal_vendor_site_name
        ? (this.$route.query.disposal_vendor_site_name.includes(',')
          ? this.$route.query.disposal_vendor_site_name.split(',')
          : [this.$route.query.disposal_vendor_site_name])
        : [],
        waste_category_name: this.$route.query.waste_category_name || "",
        customer_name: this.$route.query.customer_name || "",
        discharger_name: this.$route.query.discharger_name || "",
        discharger_site_name: this.$route.query.discharger_site_name || "",
        transport_vendor_1_name: this.$route.query.transport_vendor_1_name || "",
        disposal_vendor_name: this.$route.query.disposal_vendor_name || "",
        final_disposal_site_name: this.$route.query.final_disposal_site_name || "",
        date_of_issue_from: this.$route.query.date_of_issue_from || "",
        date_of_issue_to: this.$route.query.date_of_issue_to || "",
        sub_transport_vendor_from: this.$route.query.sub_transport_vendor_from || "",
        sub_transport_vendor_to: this.$route.query.sub_transport_vendor_to || "",
        sub_disposal_vendor_from: this.$route.query.sub_disposal_vendor_from || "",
        sub_disposal_vendor_to: this.$route.query.sub_disposal_vendor_to || "",
        final_disposal_site_treatment_from: this.$route.query.final_disposal_site_treatment_from || "",
        final_disposal_site_treatment_to: this.$route.query.final_disposal_site_treatment_to || "",
        is_registration_incomplete: this.$route.query.is_registration_incomplete || "",
        is_not_related: this.$route.query.is_not_related || "",
        is_transport_finish_report_incomplete: this.$route.query.is_transport_finish_report_incomplete || "",
        is_disposal_finish_report_incomplete: this.$route.query.is_disposal_finish_report_incomplete || "",
        is_final_disposal_finish_report_incomplete: this.$route.query.is_final_disposal_finish_report_incomplete || "",
        is_completed: this.$route.query.is_completed || "",
        column: this.$route.query.column || "date_of_issue",
        dir: this.$route.query.dir || "DESC",
        page: this.$route.query.page || 1,
        searchToken: 0
      },
      total_records: 0,
      isLoading: false
    };
  },
  created() {
    if (typeof this.$route.query.date_of_issue_from === 'undefined') {
      this.filters.date_of_issue_from = this.prevMonth;
    }
    if (typeof this.$route.query.date_of_issue_to === 'undefined') {
      this.filters.date_of_issue_to = this.currentMonth;
    }
    this.getOptions();
    this.getData();
  },
  methods: {
    async getOptions() {
      this.isLoading = true;
      const sendApiProject = await this.$http.get(apiEndpoints.waste_category_for_options, {});
      const { status, data } = sendApiProject;

      if (status && data.result) {
        let option = null;
        let value = "";
        let name = "";
        this.waste_categories.push({value:'',text:''});
        data.result.forEach(waste_category => {
          value = waste_category.jw_waste_category_id;
          name = waste_category.jw_waste_category_id + " : "+ waste_category.name_abbreviated;
          option = {value:value,text:name};//value;//{value: value , text: name };
          this.waste_categories.push(option);
        });
      }

      const sendApiProjectForFactory = await this.$http.get(apiEndpoints.get_factory_options, {});

      if (sendApiProjectForFactory.status && sendApiProjectForFactory.data.result) {
        this.factories = sendApiProjectForFactory.data.result;
        let other = {name_abbreviated:'他社', discharger_registration_number: 'other'}
        this.factories.push(other);
      }

      this.isLoading = false;
    },
    async getData() {
      this.isLoading = true;

      let waste_category_name = this.filters.waste_category_name;

      const sendApiProject = await this.$http.get(
        apiEndpoints.search_manifest,
        this.filters
      );
      const { status, data } = sendApiProject;

      if (status && data.result) {
        this.total_records = data.result.total;
        this.data = data.result.data;
        const meta = this.$_.isEmpty(data.result.meta) ? [] : data.result.meta;
        this.setMeta(meta);
      }

      this.isLoading = false;
    },
    search() {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    onChangePage(event, page) {
      this.filters.page = page;
      this.getData();
    },
    clearDataSearch() {
      for (const key in this.filters) {
        let type = this.filters[key]
        this.filters[key] = '';
        if (Array.isArray(type)) {
          this.filters[key] = [];
        }
      }
      this.filters.column = "date_of_issue";
      this.filters.dir = "DESC";
      this.filters.date_of_issue_from = this.prevMonth;
      this.filters.date_of_issue_to = this.currentMonth;
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    fakeOptions(number) {
      let options = [];
      for (let i = 1; i <= number; i++) {
        options.push({ id: i, text: "Option " + i });
      }

      return options;
    },
    getManifestType(id = null)
    {
      return id ? this.manifest_type_cd.find(item => item.value == id)?.text : '';
    },
    getTreatmentMethod(id = null)
    {
      return id ? this.zz_jw_treatment_methods.find(item => item.value == id)?.text : '';
    },
    getClassification(id = null) {
      return id ? this.classifications.find(item => item.id == id)?.text : '';
    },
    onRedirectRoute(id) {
      this.onHistoryManifestEdit();
      this.redirectRoute('manifests.edit', { id: id }, {}, this.queryPage, 'manifestEdit');
    },
    onRedirectRouteTargetBlank(id) {
      this.onHistoryManifestEdit();
      this.redirectRouteTargetBlank('manifests.edit', { id: id }, {}, this.queryPage, 'manifestEdit');
    },
    onHistoryManifestEdit() {
      this.supportLocalStorage({source: 'manifests'}, 'historyManifestEdit')
    },
    getWasteCategoryOptions(){
      let options = [];
      this.waste_categories.forEach(function(item){
        options.push({value: item.jw_waste_category_id , text: item.name_abbreviated +"("+ item.jw_waste_category_id + ")"})
      });
      return options;
    },
    getJwnUnit(code){
      const jwUnits = this.$store.getters['options/options_tables'].zz_jw_units ?? [];

      let name = jwUnits.filter(o => {
        return o.id == code
      });
      if(name.length > 0) return name[0].jw_unit;
      return '';
    },
    async getJWNData(){
      this.isLoading = true;
      const sendApiProject = await this.$http.get(
        apiEndpoints.get_jwn_manifest_manual,
      );

      const { status, data } = sendApiProject;

      if (status && data.result) {
        if(data.result.is_reserved){
          this.infoToast('既にJWNからの情報取得が予約されています。');
        }else{
          this.successToast('JWNからの情報取得を予約しました。');
        };
      }

      this.isLoading = false;
    },

    getFixVal(item, isQuantity = true){
     
      // 数量確定者を見て、それによりどの数量を確定数量とするか判断する
      // 単位はコードから名称にすること

      // 対応するJWNマニフェストが存在する場合はJWNの情報を優先する。
      // JWNがあるけど該当の情報が空の場合は空で出てよいものとする（処分前だけど数量確定者が処分の場合等）
      let target = (item.jwn_manifests) ? item.jwn_manifests: item;

      // 紙の場合は全て同じ数量が登録されている（はず）なのでいずれかを設定する
      if(target.manifest_type_cd == this.$constant.zzManifestTypes.paper){
        if(isQuantity){
          return target.amount_of_emissions ?? target.sub_disposal_vendor_disposal_amount ?? target.sub_transport_vendor_1_transport_amount ??
          target.sub_transport_vendor_2_transport_amount ?? target.sub_transport_vendor_3_transport_amount ?? target.sub_transport_vendor_4_transport_amount ??
          target.sub_transport_vendor_5_transport_amount;
        }else{
          return target.quantity_confirmation_unit_cd ?? target.sub_disposal_vendor_disposal_unit ?? target.sub_transport_vendor_1_transport_unit ??
          target.sub_transport_vendor_2_transport_unit ?? target.sub_transport_vendor_3_transport_unit ?? target.sub_transport_vendor_4_transport_unit ??
          target.sub_transport_vendor_5_transport_unit;
        }
      }

      switch(target.quantity_confirmation_company_type_cd){
        case this.$constant.zzJwQuantityConfirmationCompanyTypes.none:
          // 空
          return "数量確定者未設定";
        case this.$constant.zzJwQuantityConfirmationCompanyTypes.discharger:
          // 排出量
          return (isQuantity)?target.amount_of_emissions:target.quantity_confirmation_unit_cd;
        case this.$constant.zzJwQuantityConfirmationCompanyTypes.disposal:
          // 受入量
          return (isQuantity)?target.sub_disposal_vendor_disposal_amount:target.sub_disposal_vendor_disposal_unit;
        case this.$constant.zzJwQuantityConfirmationCompanyTypes.trans1st:
          // 運搬量
          return (isQuantity)?target.sub_transport_vendor_1_transport_amount:target.sub_transport_vendor_1_transport_unit;
        case this.$constant.zzJwQuantityConfirmationCompanyTypes.trans2nd:
          return (isQuantity)?target.sub_transport_vendor_2_transport_amount:target.sub_transport_vendor_2_transport_unit;
        case this.$constant.zzJwQuantityConfirmationCompanyTypes.trans3rd:
          return (isQuantity)?target.sub_transport_vendor_3_transport_amount:target.sub_transport_vendor_3_transport_unit;
        case this.$constant.zzJwQuantityConfirmationCompanyTypes.trans4th:
          return (isQuantity)?target.sub_transport_vendor_4_transport_amount:target.sub_transport_vendor_4_transport_unit;
        case this.$constant.zzJwQuantityConfirmationCompanyTypes.trans5th:
          return (isQuantity)?target.sub_transport_vendor_5_transport_amount:target.sub_transport_vendor_5_transport_unit;
      }
    },
    // 運搬数量の取得
    getTransportAmount(item){
      let amountUnit = 
      (item.sub_transport_vendor_1_transport_amount ??
      item.sub_transport_vendor_2_transport_amount ??
      item.sub_transport_vendor_3_transport_amount ??
      item.sub_transport_vendor_4_transport_amount ??
      item.sub_transport_vendor_5_transport_amount ?? '')
      + ' ' +
      (this.getJwnUnit(item.sub_transport_vendor_1_transport_unit) ??
      this.getJwnUnit(item.sub_transport_vendor_2_transport_unit) ??
      this.getJwnUnit(item.sub_transport_vendor_3_transport_unit) ??
      this.getJwnUnit(item.sub_transport_vendor_4_transport_unit) ??
      this.getJwnUnit(item.sub_transport_vendor_5_transport_unit) ?? ''
    ); 
    return amountUnit;
    },
    // 確定数量の取得
    getFixQuantity(item){
      let isQuantity = true;
      return this.getFixVal(item, isQuantity);
    },
    getFixUnit(item){
      let isQuantity = false;
      return this.getJwnUnit(this.getFixVal(item,isQuantity));
    },
  },
  computed: {
    currentMonth() {
      return this.getToday();
    },
    prevMonth() {
      return this.addOrSubtractTimeFromDate(1, 'months', 'subtract', this.getToday(), 'YYYY-MM-DD');
    },
    headers() {
      return [
        {
          text: "交付日",
          value: "date_of_issue",
          stickyColumn: true,
          isRowHeader: true,
          sortable: true,
          additionalClasses: "date_of_issue",
        },
        {
          text: "マニフェスト番号",
          value: "number_of_issue",
          stickyColumn: true,
          isRowHeader: true,
          sortable: false,
          additionalClasses: "number_of_issue",
        },
        {
          text: "管理番号",
          value: "control_number",
          stickyColumn: true,
          isRowHeader: true,
          sortable: false,
          additionalClasses: "control_number",
        },
        {
          text: "媒体",
          value: "manifesh_type_cd",
          sortable: false,
          additionalClasses: "manifesh_type_cd",
        },
        {
          text: "分類",
          value: "classification",
          sortable: false,
          additionalClasses: "classification",
        },
        {
          text: "得意先",
          value: "customer_name",
          sortable: false,
          additionalClasses: "customer_name",
        },
        {
          text: "排出事業者",
          value: "discharger_name",
          sortable: false,
          additionalClasses: "discharger_name",
        },
        {
          text: "排出事業場",
          value: "discharger_site_name",
          sortable: false,
          additionalClasses: "discharger_site_name",
        },
        {
          text: "廃棄物種類",
          value: "waste_category_name",
          sortable: false,
          additionalClasses: "waste_category_name",
        },
        {
          text: "廃棄物の名称",
          value: "waste_name",
          sortable: false,
          additionalClasses: "waste_name",
        },
        {
          text: "運搬受託者",
          value: "transport_vendor_1_name",
          sortable: false,
          additionalClasses: "transport_vendor_1_name",
        },
        {
          text: "処分事業場",
          value: "disposal_vendor_name",
          sortable: false,
          additionalClasses: "disposal_vendor_name",
        },
        {
          text: "処分方法",
          value: "disposal_vendor_site_treatment_method",
          sortable: false,
          additionalClasses: "disposal_vendor_site_treatment_method",
        },
        {
          text: "処分終了日",
          value: "sub_disposal_vendor_end_date",
          sortable: false,
          additionalClasses: "sub_disposal_vendor_end_date",
        },
        {
          text: "運搬数量",
          value: "sub_transport_vendor_transport_amount",
          sortable: false,
          additionalClasses: "sub_transport_vendor_transport_amount",
        },
        {
          text: "実数量",
          value: "sub_disposal_vendor_disposal_amount",
          sortable: false,
          additionalClasses: "sub_disposal_vendor_disposal_amount",
        },
        {
          text: "単位",
          value: "sub_disposal_vendor_disposal_unit",
          sortable: false,
          additionalClasses: "sub_disposal_vendor_disposal_unit",
        },
        {
          text: "最終処分地",
          value: "final_disposal_site_by_manifest.final_disposal_site_name",
          sortable: false,
          additionalClasses: "final_disposal_site_name",
        },
        {
          text: "最終処分終了日",
          value: "final_disposal_site_by_manifest.final_disposal_site_treatment_end_date",
          sortable: false,
          additionalClasses: "final_disposal_site_treatment_end_date",
        },
        {
          text: "返却日B2",
          value: "B2_return_date",
          sortable: false,
          additionalClasses: "B2_return_date",
        },
        {
          text: "返却日C2",
          value: "C2_return_date",
          sortable: false,
          additionalClasses: "C2_return_date",
        },
        {
          text: "返却日D",
          value: "D1_return_date",
          sortable: false,
          additionalClasses: "D1_return_date",
        },
        {
          text: "返却日E",
          value: "E1_return_date",
          sortable: false,
          additionalClasses: "E1_return_date",
        },
        {
          text: "備考",
          value: "remarks",
          sortable: false,
          additionalClasses: "remarks",
        },
        {
          text: "２次マニフェスト",
          value: "manifestNumber2nd.issue_number_2nd",
          sortable: false,
          additionalClasses: "issue_number_2nd",
        }
      ];
    },
    queryPage() {
      return this.$route.query;
    },
    totalRows() {
      return this.total_records;
    },
    manifest_type_cd()
    {
      let manifest_type_cd = this.$store.getters["options/options_tables"]?.zz_manifest_types ?? [];

      return manifest_type_cd?.map(item => ({value: item.id, text: item.manifest_type}));
    },
    zz_jw_treatment_methods()
    {
      let zz_jw_treatment_methods = this.$store.getters["options/options_tables"]?.zz_jw_treatment_methods ?? [];

      return zz_jw_treatment_methods?.map(item => ({value: item.id, text: item.jw_treatment_method}));
    },
    classifications() {
      return [
        {
          id: 1,
          text: '通常'
        },
        {
          id: 2,
          text: '積替保管'
        },
      ];
    },
    disposal_vendor_site_name() {
      return [
        {
          id: 1,
          text: '豊田第１工場'
        },
        {
          id: 2,
          text: '豊田第２工場'
        },
        {
          id: 3,
          text: '本社工場'
        },
        {
          id: 4,
          text: '他社'
        },
      ]
    },
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler(newVal, oldVal) {
        const initQueries = {
          date_of_issue_from: '',
          date_of_issue_to: ''
        };
        if (typeof this.$route.query.date_of_issue_from === 'undefined') {
          initQueries.date_of_issue_from = this.prevMonth;
        }
        if (typeof this.$route.query.date_of_issue_to === 'undefined') {
          initQueries.date_of_issue_to = this.currentMonth;
        }

        this.updateFiltersWithoutSearch(initQueries);
        this.updateUrlFilters();
      }
    }
  }
};
</script>
<template>
  <Layout>
    <b-card class="mb-1">
        <b-row class="mb-2">
          <b-col cols="6">
            <div class="gap-2 d-flex">
              <label for="number_of_issue" class="col-form-label text-nowrap cus-label">マニフェスト番号</label>
              <b-form-input
                name="number_of_issue"
                id="number_of_issue"
                v-model="filters.number_of_issue"
                type="text"></b-form-input>
            </div>
          </b-col>
          <b-col cols="6">
            <b-form-checkbox
              class="d-flex w-100 align-items-center"
              id="number_of_issue_get_blank"
              name="number_of_issue_get_blank"
              v-model="filters.number_of_issue_get_blank"
              value="1"
              unchecked-value="0"
            >
              マニフェスト番号未設定
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="6">
            <div class="gap-2 d-flex">
              <label for="control_number" class="col-form-label text-nowrap cus-label">管理番号</label>
              <b-form-input
                id="control_number"
                name="control_number"
                v-model="filters.control_number"
                type="text"></b-form-input>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <div class="d-flex gap-2">
              <label for="manifest_type_cd" class="cus-label">媒体</label>
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  id="manifest_type_cd"
                  class="d-flex gap-3 align-items-center"
                  :options="manifest_type_cd"
                  :aria-describedby="ariaDescribedby"
                  v-model="filters.manifest_type_cd"
                  text-field="text"
                  value-field="value"
                  name="manifest_type_cd"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <div class="d-flex gap-2">
              <label for="classifications" class="cus-label">分類</label>
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  id="classifications"
                  class="d-flex gap-3 align-items-center"
                  :options="classifications"
                  :aria-describedby="ariaDescribedby"
                  v-model="filters.classifications"
                  text-field="text"
                  value-field="id"
                  name="classifications"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <div class="d-flex gap-2">
              <label for="disposal_vendor_site_name" class="cus-label">処分先</label>
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  id="disposal_vendor_site_name"
                  class="d-flex gap-3 align-items-center"
                  :options="factories"
                  v-model="filters.disposal_vendor_site_name"
                  :aria-describedby="ariaDescribedby"
                  text-field="name_abbreviated"
                  value-field="discharger_registration_number"
                  name="disposal_vendor_site_name"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="6">
            <div class="d-flex gap-2">
              <label for="customer_name" class="col-form-label text-nowrap cus-label">得意先</label>
              <b-form-input
                id="customer_name"
                name="customer_name"
                v-model="filters.customer_name"
                type="text"
              >
              </b-form-input>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="6">
            <div class="d-flex gap-2">
              <label for="discharger_name" class="col-form-label text-nowrap cus-label">排出事業者</label>
              <b-form-input
                id="discharger_name"
                name="discharger_name"
                v-model="filters.discharger_name"
                type="text"></b-form-input>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="d-flex gap-2">
            <label for="discharger_site_name" class="col-form-label text-nowrap cus-label">排出事業場</label>
            <b-form-input
              id="discharger_site_name"
              v-model="filters.discharger_site_name"
              name="discharger_site_name"
              type="text"></b-form-input>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="6">
            <div class="d-flex gap-2">
              <label for="transport_vendor_1_name" class="col-form-label text-nowrap cus-label">運搬受託者</label>
              <b-form-input
                id="transport_vendor_1_name"
                name="transport_vendor_1_name"
                v-model="filters.transport_vendor_1_name"
                type="text"></b-form-input>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="d-flex gap-2">
              <label for="disposal_vendor_name" class="col-form-label text-nowrap cus-label">処分受託者</label>
              <b-form-input
                id="disposal_vendor_name"
                name="disposal_vendor_name"
                v-model="filters.disposal_vendor_name"
                type="text"></b-form-input>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="6">
            <div class="d-flex gap-2">
              <label for="waste_categories" class="col-form-label text-nowrap cus-label">廃棄物の種類</label>
              <!--
              <Multiselect
                id="waste_categories"
                v-if="waste_categories"
                :options="waste_categories"
                :multiple="true"
                v-model="filters.waste_category_name"
                placeholder=""
                track-by="value"
                label="text"
              />
              -->
              <b-form-select
                class="form-select custom-select"
                v-model="filters.waste_category_name"
                :options="waste_categories"
                value-field="value"
                text-field="text"/>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="6">
            <div class="d-flex gap-2">
              <label for="final_disposal_site_name" class="col-form-label text-nowrap cus-label">最終処分地</label>
              <b-form-input
                id="final_disposal_site_name"
                name="final_disposal_site_name"
                v-model="filters.final_disposal_site_name"
                type="text"></b-form-input>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="6">
            <div class="d-flex gap-2">
              <label for="" class="col-form-label text-nowrap cus-label">交付日</label>
              <div class="d-flex gap-2 align-items-baseline w-100 input-with-checkbox">
                <div class="cell-40">
                  <date-picker
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                    position="left"
                    v-model="filters.date_of_issue_from"
                  ></date-picker>
                </div>
                <div class="align-self-center cell-5 d-flex justify-content-center">～</div>
                <div class="cell-40">
                  <date-picker
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                    position="left"
                    v-model="filters.date_of_issue_to"
                  ></date-picker>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="d-flex gap-2">
              <label for="" class="col-form-label text-nowrap cus-label">運搬終了日</label>
              <div class="d-flex gap-2 align-items-baseline w-100 input-with-checkbox">
                <div class="cell-40">
                  <date-picker
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                    position="left"
                    v-model="filters.sub_transport_vendor_from"
                  ></date-picker>
                </div>
                <div class="align-self-center cell-5 d-flex justify-content-center">～</div>
                <div class="cell-40">
                  <date-picker
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                    position="left"
                    v-model="filters.sub_transport_vendor_to"
                  ></date-picker>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="6">
            <div class="d-flex gap-2 w-100">
              <label for="" class="col-form-label text-nowrap cus-label">処分終了日</label>
              <div class="d-flex gap-2 align-items-baseline w-100 input-with-checkbox">
                <div class="cell-40">
                  <date-picker
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                    position="left"
                    v-model="filters.sub_disposal_vendor_from"
                  ></date-picker>
                </div>
                <div class="align-self-center cell-5 d-flex justify-content-center">～</div>
                <div class="cell-40">
                  <date-picker
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                    position="left"
                    v-model="filters.sub_disposal_vendor_to"
                  ></date-picker>
                </div>
              </div>
            </div>
          </b-col>
          <b-col>
            <div class="d-flex gap-2">
              <label for="" class="col-form-label text-nowrap cus-label">最終処分終了日</label>
              <div class="d-flex gap-2 align-items-baseline w-100 input-with-checkbox">
                <div class="cell-40">
                  <date-picker
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                    position="left"
                    v-model="filters.final_disposal_site_treatment_from"
                  ></date-picker>
                </div>

                <div class="align-self-center cell-5 d-flex justify-content-center">～</div>
                <div class="cell-40">
                  <date-picker
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                    position="left"
                    v-model="filters.final_disposal_site_treatment_to"
                  ></date-picker>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col cols="12">
            <div class="d-flex gap-2 w-100">
              <label for="" class="col-form-label text-nowrap cus-label">状態（電子）</label>
                <b-form-checkbox
                  class="cell-15"
                  id="is_registration_incomplete"
                  name="is_registration_incomplete"
                  value="1"
                  v-model="filters.is_registration_incomplete"
                >
                本登録未送信
                </b-form-checkbox>
                <b-form-checkbox
                  class="cell-15"
                  id="is_not_related"
                  name="is_not_related"
                  value="1"
                  v-model="filters.is_not_related"
                >
                紐づけマニフェスト無し
                </b-form-checkbox>
                <b-form-checkbox
                  class="cell-15"
                  id="is_transport_finish_report_incomplete"
                  name="is_transport_finish_report_incomplete"
                  value="1"
                  v-model="filters.is_transport_finish_report_incomplete"
                >運搬終了報告未送信
                </b-form-checkbox>
                <b-form-checkbox
                  class="cell-15"
                  id="is_disposal_finish_report_incomplete"
                  name="is_disposal_finish_report_incomplete"
                  value="1"
                  v-model="filters.is_disposal_finish_report_incomplete"
                >
                処分終了報告未送信
                </b-form-checkbox>
                <b-form-checkbox
                  class="cell-15"
                  id="is_final_disposal_finish_report_incomplete"
                  name="is_final_disposal_finish_report_incomplete"
                  value="1"
                  v-model="filters.is_final_disposal_finish_report_incomplete"
                >
                最終処分終了報告未送信
                </b-form-checkbox>
                <b-form-checkbox
                  class="cell-15"
                  id="is_completed"
                  name="is_completed"
                  value="1"
                  v-model="filters.is_completed"
                >
                入力完了
                </b-form-checkbox>   
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <div class="d-flex justify-content-center">
            <b-button size="lg" variant="primary" @click="search" class="me-2">
              <div class="d-flex align-items-center justify-content-center">
                <i class="fas fa-search"></i> {{ this.$lang.button.search }}
              </div>
            </b-button>
            <b-button
              size="lg"
              variant="dark"
              @click="clearDataSearch"
              class="me-2"
            >
              <i class="fas fa-eraser"></i> {{ this.$lang.button.clear }}
            </b-button>
            <b-button
              size="lg"
              variant="success"
              @click="getJWNData"
            >
              <i class="fas fa-sync"></i> JWN情報取得
            </b-button>
          </div>
        </b-row>
      </b-card>
    <b-card class="p-0">
        <CommonTableComponent :height-class="`table-wrapper-500`" class="text-small">
          <thead class="table-light">
            <tr>
              <th
                v-for="(item, index) in headers"
                :key="index"
                :class="[getHeaderClass(item), index < 3 && 'sticky-header-custom '+ `p-${index+1}`]"
              >
                <span v-if="item.sortable" @click="clickSort(item.value)" >
                  {{ item.text }}
                  <i :class="getSortClass(item.value)"></i>
                </span>
                <span v-else>
                  {{ item.text }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="cursor-pointer"
              v-for="(item, index) of data"
              :key="index"
              @click.exact="onRedirectRoute(item.id)"
              @click.ctrl="onRedirectRouteTargetBlank(item.id)"
            >
              <td class="sticky-column-custom p-1">{{ item.date_of_issue }}</td>
              <td class="sticky-column-custom p-2">{{ item.number_of_issue }}</td>
              <td class="sticky-column-custom p-3">{{ item.control_number }}</td>
              <td>{{ getManifestType(item.manifest_type_cd) }}</td>
              <td>{{ getClassification(item.classification) }}</td>
              <td>{{ item.customer_name }}</td>
              <td>{{ item.discharger_name }}</td>
              <td>{{ item.discharger_site_name }}</td>
              <td>{{ item.waste_category.name_abbreviated }}</td>
              <td>{{ item.waste_name }}</td>
              <td>{{ item.transport_vendor_1_name }}</td>
              <td>{{ item.disposal_vendor_site_name }}</td>
              <td>{{ getTreatmentMethod(item.disposal_vendor_site_treatment_method) }}</td>
              <td>{{ item.sub_disposal_vendor_end_date ? item.sub_disposal_vendor_end_date
                  : (item.jwn_manifests ? item.jwn_manifests.sub_disposal_vendor_end_date : '')}}</td>
              <td>{{ getTransportAmount(item) }}</td>
              <td>{{ getFixQuantity(item) }}</td>
              <td>{{ getFixUnit(item) }}</td>
              <td>
                <div v-for="(item, index) in item.final_disposal_site_by_manifest">
                  {{ item.final_disposal_site_name }}
                </div>
              </td>
              <td>
                <div v-for="(item, index) in item.final_disposal_site_by_manifest">
                  {{ item.final_disposal_site_treatment_end_date }}
                </div>
              </td>
              <td>{{ item.B2_return_date }}</td>
              <td>{{ item.C2_return_date }}</td>
              <td>{{ item.D1_return_date }}</td>
              <td>{{ item.E1_return_date }}</td>
              <td>
                <p>{{ item.remarks_1 }}</p>
                <p>{{ item.remarks_2 }}</p>
                <p>{{ item.remarks_3 }}</p>
                <p>{{ item.remarks_4 }}</p>
                <p>{{ item.remarks_5 }}</p>
              </td>
              <td>
                <div v-for="(wasteAfterTreatment, index) in item.wastes_after_treatment_by_manifest">
                  {{ wasteAfterTreatment.issue_number_2nd }}
                </div>
              </td>
            </tr>
            <tr v-if="!data.length && !isLoading">
              <td :colspan="headers.length" class="text-center">
                データなし。
              </td>
            </tr>
          </tbody>
        </CommonTableComponent>
        <div
          class="d-flex justify-content-between mt-3"
          v-if="meta.total && Object.keys(meta).length"
        >
          <div class="d-flex align-items-center">
            <b-pagination
              v-model="filters.page"
              :total-rows="meta.total"
              :per-page="meta.per_page"
            ></b-pagination>
          </div>
          <div class="d-flex align-items-center">
            <div class="me-2">
              {{ meta.from }} - {{ meta.to }} / {{ meta.total }}
            </div>
          </div>
        </div>
      </b-card>
  </Layout>
</template>
<style lang="scss" scoped>
.sticky-header-custom {
  position: sticky;
  z-index: 10 !important;
  top: 0;
  left: -1px;
  &.p-1 {
    min-width: 83px;
  }
  &.p-2 {
    left: 81px;
    width: 110px;
  }
  &.p-3 {
    left: 190px;
    min-width: 110px;
  }
}
.sticky-column-custom {
  position: sticky;
  z-index: 1 !important;
  left: -1px;
  &.p-1 {
    min-width: 83px;
  }
  &.p-2 {
    left: 81px;
    width: 110px;
  }
  &.p-3 {
    left: 190px;
    min-width: 110px;
  }

}
td {
    background-color: white;
}
.cus-label{
  flex: 0 0 115px;
}
.text-small {
  font-size: 12px;
}

.date_of_issue{
  min-width:100px;
}
.number_of_issue{
  min-width:100px;
}
.control_number{
  min-width:100px;
}
.manifesh_type_cd{
  min-width:50px;
}
.classification{
  min-width:70px;
}
.customer_name{
  min-width:200px;
}
.discharger_name{
  min-width:200px;
}
.discharger_site_name{
  min-width:200px;
}
.waste_name{
  min-width:150px;
}
.transport_vendor_1_name{
  min-width:200px;
}
.disposal_vendor_name{
  min-width:200px;
}
.disposal_vendor_site_treatment_method{
  min-width:100px;
}
.sub_disposal_vendor_end_date{
  min-width:100px;
}
.sub_transport_vendor_transport_amount{
  min-width:80px;
}
.sub_disposal_vendor_disposal_amount{
  min-width:80px;
}
.sub_disposal_vendor_disposal_unit{
  min-width:50px;
}
.final_disposal_site_name{
  min-width:100px;
}
.final_disposal_site_treatment_end_date{
  min-width:100px;
}
.B1_return_date{
  min-width:100px;
}
.B2_return_date{
  min-width:100px;
}
.C2_return_date{
  min-width:100px;
}
.D1_return_date{
  min-width:100px;
}
.E1_return_date{
  min-width:100px;
}
.remarks{
  min-width:200px;
}
.issue_number_2nd{
  min-width:100px;
}
</style>
